import { render, staticRenderFns } from "./Scheme4.vue?vue&type=template&id=17bf27b4&scoped=true"
import script from "./Scheme4.vue?vue&type=script&lang=js"
export * from "./Scheme4.vue?vue&type=script&lang=js"
import style0 from "./Scheme4.vue?vue&type=style&index=0&id=17bf27b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17bf27b4",
  null
  
)

export default component.exports